/**
 * Camada 3 - Contract Validation
 *
 * Compara os services do Admin com a spec OpenAPI/Swagger da API.
 * Detecta divergências entre o que o front envia/espera e o que a API define.
 */

// Manifesto declarativo: o que cada service do Admin ESPERA da API.
// Baseado na leitura real dos services e dos componentes que consomem os dados.
const SERVICE_CONTRACTS = [
  {
    service: 'professionalsService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/professionals',
        expectedResponseFields: ['id', 'name', 'email', 'phone', 'specialty', 'registrationNumber', 'places'],
        requestBody: null,
      },
      {
        name: 'getById',
        method: 'GET',
        path: '/api/professionals/{id}',
        expectedResponseFields: ['id', 'name', 'email', 'phone', 'specialty', 'registrationNumber', 'title', 'description', 'bio'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/professionals',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'title', 'specialty', 'registrationNumber', 'phone', 'email', 'description', 'bio'],
      },
      {
        name: 'update',
        method: 'PUT',
        path: '/api/professionals/{id}',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'title', 'specialty', 'registrationNumber', 'phone', 'email', 'description', 'bio'],
      },
      {
        name: 'delete',
        method: 'DELETE',
        path: '/api/professionals/{id}',
        expectedResponseFields: [],
        requestBody: null,
      },
      {
        name: 'getPlacesSchedules',
        method: 'GET',
        path: '/api/professionals/{id}/places-schedules',
        expectedResponseFields: ['placeProfessionalId', 'place', 'schedules'],
        requestBody: null,
      },
    ],
  },
  {
    service: 'servicesService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/services',
        expectedResponseFields: ['id', 'name', 'description', 'category', 'defaultDurationMinutes', 'defaultPrice'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/services',
        expectedResponseFields: ['id', 'name', 'defaultDurationMinutes', 'defaultPrice'],
        requestBody: ['name', 'description', 'category', 'defaultDurationMinutes', 'defaultPrice'],
      },
      {
        name: 'update',
        method: 'PUT',
        path: '/api/services/{id}',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'description', 'category', 'defaultDurationMinutes', 'defaultPrice'],
      },
      {
        name: 'delete',
        method: 'DELETE',
        path: '/api/services/{id}',
        expectedResponseFields: [],
        requestBody: null,
      },
    ],
  },
  {
    service: 'placesService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/places',
        expectedResponseFields: ['professionals', 'services', 'payments', 'places'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/places',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'description', 'email', 'phone', 'website', 'addressStreet', 'addressNumber', 'addressComplement', 'addressNeighborhood', 'addressCity', 'addressState', 'addressZipCode'],
      },
      {
        name: 'update',
        method: 'PUT',
        path: '/api/places/{id}',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'description', 'email', 'phone', 'website', 'addressStreet', 'addressNumber', 'addressComplement', 'addressNeighborhood', 'addressCity', 'addressState', 'addressZipCode'],
      },
    ],
  },
  {
    service: 'schedulesService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/schedules',
        expectedResponseFields: ['schedules'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/schedules',
        expectedResponseFields: ['id', 'name', 'placeId', 'professionalId'],
        requestBody: ['professionalId', 'placeId', 'name', 'description', 'maxBookingDaysAhead', 'maxAvailableDaysToShow', 'minimumAdvanceBookingHours', 'startDate', 'endDate'],
      },
      {
        name: 'addShift',
        method: 'POST',
        path: '/api/schedules/{id}/shifts',
        expectedResponseFields: ['id', 'startTime', 'endTime'],
        requestBody: ['scheduleId', 'startTime', 'endTime', 'name', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'serviceIds'],
      },
    ],
  },
  {
    service: 'paymentsService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/payments',
        expectedResponseFields: ['id', 'name', 'type', 'description', 'icon', 'isGlobal', 'displayOrder'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/payments',
        expectedResponseFields: ['id', 'name', 'type'],
        requestBody: ['type', 'name', 'description', 'icon'],
      },
    ],
  },
  {
    service: 'personsService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/persons',
        expectedResponseFields: ['id', 'name', 'email', 'phone'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/persons',
        expectedResponseFields: ['id', 'name'],
        requestBody: ['name', 'email', 'phone', 'cpf', 'birthDate', 'address', 'notes'],
      },
    ],
  },
  {
    service: 'placeProfessionalsService',
    methods: [
      {
        name: 'create',
        method: 'POST',
        path: '/api/places/{placeId}/professionals',
        expectedResponseFields: ['id', 'professionalId'],
        requestBody: ['professionalId'],
      },
    ],
  },
  {
    service: 'placeServicesService',
    methods: [
      {
        name: 'create',
        method: 'POST',
        path: '/api/places/{placeId}/services',
        expectedResponseFields: ['id', 'serviceId'],
        requestBody: ['serviceId'],
      },
    ],
  },
  {
    service: 'placeServiceProfessionalsService',
    methods: [
      {
        name: 'create',
        method: 'POST',
        path: '/api/places/{placeId}/services/{serviceId}/professionals',
        expectedResponseFields: ['id'],
        requestBody: ['placeProfessionalId'],
      },
    ],
  },
  {
    service: 'placeServicePaymentsService',
    methods: [
      {
        name: 'create',
        method: 'POST',
        path: '/api/places/{placeId}/services/{serviceId}/payments',
        expectedResponseFields: ['id'],
        requestBody: ['paymentId', 'defaultPrice'],
      },
    ],
  },
  {
    service: 'pagesService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/pages',
        expectedResponseFields: ['id', 'title', 'slug', 'type', 'isPublished'],
        requestBody: null,
      },
      {
        name: 'create',
        method: 'POST',
        path: '/api/pages',
        expectedResponseFields: ['id', 'title', 'slug'],
        requestBody: ['title', 'slug', 'type', 'templateId', 'config', 'customStyles'],
      },
    ],
  },
  {
    service: 'dashboardService',
    methods: [
      {
        name: 'getStats',
        method: 'GET',
        path: '/api/dashboard/stats',
        expectedResponseFields: ['professionals', 'services', 'places', 'agendas', 'appointments'],
        requestBody: null,
      },
    ],
  },
  {
    service: 'entitiesService',
    methods: [
      {
        name: 'getAll',
        method: 'GET',
        path: '/api/entities',
        expectedResponseFields: [],
        requestBody: null,
      },
    ],
  },
  {
    service: 'usersService',
    methods: [
      {
        name: 'getTheme',
        method: 'GET',
        path: '/api/users/theme',
        expectedResponseFields: ['theme'],
        requestBody: null,
      },
      {
        name: 'updateTheme',
        method: 'PUT',
        path: '/api/users/theme',
        expectedResponseFields: [],
        requestBody: ['theme'],
      },
      {
        name: 'getNotificationPreferences',
        method: 'GET',
        path: '/api/users/notifications/preferences',
        expectedResponseFields: ['emailNotificationsEnabled'],
        requestBody: null,
      },
    ],
  },
  {
    service: 'reportsService',
    methods: [
      {
        name: 'getSummary',
        method: 'GET',
        path: '/api/reports/summary',
        expectedResponseFields: [],
        requestBody: null,
      },
      {
        name: 'getAppointments',
        method: 'GET',
        path: '/api/reports/appointments',
        expectedResponseFields: [],
        requestBody: null,
      },
    ],
  },
];

/**
 * Normaliza path do Swagger para comparação
 * /api/professionals/{id} → /api/professionals/{id}
 * /api/professionals/{professionalId} → /api/professionals/{id}
 */
function normalizePath(path) {
  return path.replace(/\{[^}]+\}/g, '{id}');
}

/**
 * Busca a operação no Swagger spec que corresponde ao path e method
 */
function findSwaggerOperation(spec, method, path) {
  const normalizedTarget = normalizePath(path);

  for (const [swaggerPath, methods] of Object.entries(spec.paths || {})) {
    const normalizedSwagger = normalizePath(swaggerPath);
    if (normalizedSwagger === normalizedTarget || normalizedSwagger === normalizedTarget.replace('/api', '')) {
      const op = methods[method.toLowerCase()];
      if (op) return { swaggerPath, operation: op };
    }
  }

  // Tentar sem /api prefix
  const withoutApi = normalizedTarget.replace('/api', '');
  for (const [swaggerPath, methods] of Object.entries(spec.paths || {})) {
    const normalizedSwagger = normalizePath(swaggerPath);
    if (normalizedSwagger === withoutApi) {
      const op = methods[method.toLowerCase()];
      if (op) return { swaggerPath, operation: op };
    }
  }

  return null;
}

/**
 * Extrai campos do schema do Swagger (resolve $ref se necessário)
 */
function extractSchemaFields(spec, schema) {
  if (!schema) return [];

  // Resolve $ref
  if (schema.$ref) {
    const refPath = schema.$ref.replace('#/', '').split('/');
    let resolved = spec;
    for (const part of refPath) {
      resolved = resolved?.[part];
    }
    return extractSchemaFields(spec, resolved);
  }

  // Array → pegar items
  if (schema.type === 'array' && schema.items) {
    return extractSchemaFields(spec, schema.items);
  }

  // Object → pegar properties
  if (schema.properties) {
    return Object.keys(schema.properties);
  }

  // allOf → merge
  if (schema.allOf) {
    const fields = [];
    for (const sub of schema.allOf) {
      fields.push(...extractSchemaFields(spec, sub));
    }
    return fields;
  }

  return [];
}

/**
 * Valida contratos dos services contra o Swagger spec
 * @param {object} swaggerSpec - JSON do swagger
 * @returns {{ results: Array, summary: { total, matched, mismatched, missing } }}
 */
export function validateContracts(swaggerSpec) {
  const results = [];
  let total = 0;
  let matched = 0;
  let mismatched = 0;
  let missing = 0;

  for (const serviceContract of SERVICE_CONTRACTS) {
    for (const method of serviceContract.methods) {
      total++;
      const result = {
        service: serviceContract.service,
        method: method.name,
        httpMethod: method.method,
        path: method.path,
        status: 'unknown',
        issues: [],
      };

      // Buscar operação no Swagger
      const swaggerOp = findSwaggerOperation(swaggerSpec, method.method, method.path);

      if (!swaggerOp) {
        result.status = 'missing';
        result.issues.push(`Endpoint ${method.method} ${method.path} não encontrado no Swagger`);
        missing++;
        results.push(result);
        continue;
      }

      // Verificar request body
      if (method.requestBody && method.requestBody.length > 0) {
        const requestSchema = swaggerOp.operation.requestBody?.content?.['application/json']?.schema;
        if (requestSchema) {
          const swaggerFields = extractSchemaFields(swaggerSpec, requestSchema).map(f => f.toLowerCase());
          for (const expectedField of method.requestBody) {
            if (!swaggerFields.includes(expectedField.toLowerCase())) {
              result.issues.push(`Request body: campo "${expectedField}" enviado pelo front não existe no Swagger`);
            }
          }
          // Verificar campos obrigatórios do Swagger que o front não envia
          const requiredFields = requestSchema.required || [];
          for (const reqField of requiredFields) {
            if (!method.requestBody.map(f => f.toLowerCase()).includes(reqField.toLowerCase())) {
              result.issues.push(`Request body: campo obrigatório "${reqField}" no Swagger não é enviado pelo front`);
            }
          }
        }
      }

      // Verificar response fields
      if (method.expectedResponseFields.length > 0) {
        const successResponse = swaggerOp.operation.responses?.['200'] || swaggerOp.operation.responses?.['201'];
        if (successResponse) {
          const responseSchema = successResponse.content?.['application/json']?.schema;
          if (responseSchema) {
            const swaggerResponseFields = extractSchemaFields(swaggerSpec, responseSchema).map(f => f.toLowerCase());
            for (const expectedField of method.expectedResponseFields) {
              if (swaggerResponseFields.length > 0 && !swaggerResponseFields.includes(expectedField.toLowerCase())) {
                result.issues.push(`Response: campo "${expectedField}" esperado pelo front não existe no schema do Swagger`);
              }
            }
          }
        }
      }

      if (result.issues.length === 0) {
        result.status = 'ok';
        matched++;
      } else {
        result.status = 'mismatch';
        mismatched++;
      }

      results.push(result);
    }
  }

  return {
    results,
    summary: { total, matched, mismatched, missing },
  };
}

export { SERVICE_CONTRACTS };
